export default __webpack_public_path__ + "images/ea68f7f7db6706c0910d9c893ac91a23-right-arrow-black.svg";